import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ApiKeysPage = () => {
    const [apiKeys, setApiKeys] = useState([]);
    const [panels, setPanels] = useState([]); // Paneller için
    const [showModal, setShowModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [createdKey, setCreatedKey] = useState(null); // Yeni oluşturulan key'i göstermek için
    const [copiedField, setCopiedField] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        allowedDomains: '',
        allowedIps: '',
        callbackUrl: '',
        depositCallbackUrl: '',
        withdrawCallbackUrl: '',
        siteId: '', // Site ID manuel giriş
        commissionRate: '', // Firma komisyon oranı (%)
        panelIds: [] // Bağlı taşeron/panel listesi (çoklu seçim)
    });

    const fetchKeys = async () => {
        try {
            const res = await api.getApiKeys();
            setApiKeys(res.data);
        } catch (error) {
            console.error("API anahtarları çekilemedi", error);
        }
    };

    const fetchPanels = async () => {
        try {
            const res = await api.getPanels();
            setPanels(res.data);
        } catch (error) {
            console.error("Paneller çekilemedi", error);
        }
    };

    useEffect(() => {
        document.title = 'PayzoPay - API Anahtarları';
        fetchKeys();
        fetchPanels();
    }, []);

    const resetForm = () => {
        setFormData({ name: '', allowedDomains: '', allowedIps: '', callbackUrl: '', depositCallbackUrl: '', withdrawCallbackUrl: '', siteId: '', commissionRate: '', panelIds: [] });
        setIsEditMode(false);
        setEditingId(null);
    };

    const togglePanel = (panelId) => {
        setFormData(prev => {
            const has = prev.panelIds.includes(panelId);
            return { ...prev, panelIds: has ? prev.panelIds.filter(p => p !== panelId) : [...prev.panelIds, panelId] };
        });
    };

    const handleOpenCreate = () => {
        resetForm();
        setShowModal(true);
    };

    const handleOpenEdit = (key) => {
        setFormData({
            name: key.name,
            allowedDomains: key.allowedDomains || '',
            allowedIps: key.allowedIps || '',
            callbackUrl: key.callbackUrl || '',
            depositCallbackUrl: key.depositCallbackUrl || '',
            withdrawCallbackUrl: key.withdrawCallbackUrl || '',
            siteId: key.siteId || '',
            commissionRate: (key.commissionRate ?? '') === 0 ? '0' : (key.commissionRate || ''),
            panelIds: (Array.isArray(key.panelIds) && key.panelIds.length > 0) ? key.panelIds : (key.dealerAdminId ? [key.dealerAdminId] : [])
        });
        setIsEditMode(true);
        setEditingId(key._id);
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.panelIds || formData.panelIds.length === 0) {
            alert('Lütfen en az bir departman seçin. Bu alan zorunludur.');
            return;
        }
        try {
            if (isEditMode) {
                await api.updateApiKey(editingId, formData);
                alert('API anahtarı güncellendi.');
            } else {
                const res = await api.createApiKey(formData);
                setCreatedKey(res.data); // Secret key'i göstermek için sakla
            }
            fetchKeys();
            setShowModal(false);
            resetForm();
        } catch (error) {
            alert('İşlem başarısız: ' + (error.response?.data?.error || error.message));
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Bu API anahtarını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.')) return;
        try {
            await api.deleteApiKey(id);
            fetchKeys();
        } catch (error) {
            alert('Silme başarısız.');
        }
    };

    const toggleActive = async (key) => {
        try {
            await api.updateApiKey(key._id, { isActive: !key.isActive });
            fetchKeys();
        } catch (error) {
            alert('Güncelleme başarısız.');
        }
    };

    const copyToClipboard = async (text, field) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedField(field);
            setTimeout(() => setCopiedField(null), 2000);
        } catch (err) {
            console.error('Kopyalama başarısız', err);
        }
    };

    // Stiller
    const inputStyle = { width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)', boxSizing: 'border-box' };
    const labelStyle = { display: 'block', marginBottom: '5px', fontWeight: 'bold', color: 'var(--text-color)', fontSize: '0.9em' };
    const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContentStyle = { backgroundColor: 'var(--card-bg)', padding: '20px', borderRadius: '8px', width: '500px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto', color: 'var(--text-color)' };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div>
                    <h2 style={{ color: 'var(--text-color)', margin: 0 }}>API Anahtarları</h2>
                    <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: '0.9em' }}>Dış sistemler için API anahtarlarını yönetin</p>
                </div>
                <button onClick={handleOpenCreate} style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <i className="fas fa-plus"></i> Yeni Anahtar
                </button>
            </div>

            {/* Liste */}
            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', color: 'var(--text-color)' }}>
                    <thead>
                        <tr style={{ backgroundColor: 'var(--table-header-bg)', textAlign: 'left' }}>
                            <th style={{ padding: '15px' }}>Ad</th>
                            <th>API Key</th>
                            <th>IP Whitelist</th>
                            <th>Durum</th>
                            <th>Son Kullanım</th>
                            <th>İşlemler</th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiKeys.length === 0 ? (
                            <tr><td colSpan="6" style={{ padding: '30px', textAlign: 'center', color: '#6c757d' }}>Henüz API anahtarı oluşturulmamış.</td></tr>
                        ) : (
                            apiKeys.map(key => (
                                <tr key={key._id} style={{ borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--table-row-even)' }}>
                                    <td style={{ padding: '12px 15px', fontWeight: 'bold' }}>{key.name}</td>
                                    <td><code style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: '2px 5px', borderRadius: '3px', fontFamily: 'monospace' }}>{key.apiKey.substring(0, 20)}...</code></td>
                                    <td>{key.allowedIps ? key.allowedIps : <span style={{ fontStyle: 'italic', opacity: 0.7 }}>Tümü</span>}</td>
                                    <td>
                                        <button
                                            onClick={() => toggleActive(key)}
                                            style={{
                                                padding: '4px 10px', borderRadius: '15px', border: 'none', cursor: 'pointer', fontSize: '0.85em',
                                                backgroundColor: key.isActive ? '#28a745' : '#6c757d', color: '#fff'
                                            }}
                                        >
                                            {key.isActive ? 'Aktif' : 'Pasif'}
                                        </button>
                                    </td>
                                    <td style={{ fontSize: '0.9em' }}>{key.lastUsedAt ? new Date(key.lastUsedAt).toLocaleString() : '-'}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button onClick={() => handleOpenEdit(key)} style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer' }} title="Düzenle"><i className="fas fa-edit"></i></button>
                                            <button onClick={() => handleDelete(key._id)} style={{ color: '#dc3545', background: 'none', border: 'none', cursor: 'pointer' }} title="Sil"><i className="fas fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Oluşturma/Düzenleme Modalı */}
            {showModal && (
                <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
                    <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>{isEditMode ? 'API Anahtarını Düzenle' : 'Yeni API Anahtarı'}</h3>
                        <form onSubmit={handleSubmit}>
                            <label style={labelStyle}>Anahtar Adı</label>
                            <input required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} style={inputStyle} placeholder="Örn: Site Entegrasyonu" />

                            <label style={labelStyle}>IP Whitelist (Virgülle ayırın) <span style={{ color: '#dc3545' }}>*</span></label>
                            <input required value={formData.allowedIps} onChange={e => setFormData({ ...formData, allowedIps: e.target.value })} style={inputStyle} placeholder="örn: 127.0.0.1, 192.168.1.1" />
                            <p style={{ fontSize: '0.8em', color: '#6c757d', marginTop: '-8px', marginBottom: '10px' }}>Güvenlik için zorunludur.</p>

                            <label style={labelStyle}>Güvenilir Domainler (Opsiyonel)</label>
                            <input value={formData.allowedDomains} onChange={e => setFormData({ ...formData, allowedDomains: e.target.value })} style={inputStyle} placeholder="example.com" />

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                <div>
                                    <label style={labelStyle}>Site ID (Opsiyonel)</label>
                                    <input value={formData.siteId} onChange={e => setFormData({ ...formData, siteId: e.target.value })} style={inputStyle} placeholder="Site ID" />
                                </div>
                                <div>
                                    <label style={labelStyle}>Firma Komisyon Oranı (%)</label>
                                    <input type="number" step="0.01" value={formData.commissionRate} onChange={e => setFormData({ ...formData, commissionRate: e.target.value })} style={inputStyle} placeholder="Örn: 5 veya 2.5" />
                                </div>
                            </div>

                            <label style={labelStyle}>Departmanlar (Zorunlu) — seçilenler bu anahtarla sırayla çalışır</label>
                            <div style={{ border: '1px solid var(--input-border)', borderRadius: '4px', padding: '10px', marginBottom: '10px', maxHeight: '180px', overflowY: 'auto', background: 'var(--input-bg)' }}>
                                {panels.length === 0 ? (
                                    <div style={{ fontSize: '0.85em', opacity: 0.7 }}>Departman bulunamadı.</div>
                                ) : panels.map(p => (
                                    <label key={p._id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0', cursor: 'pointer' }}>
                                        <input type="checkbox" checked={formData.panelIds.includes(p.panelId)} onChange={() => togglePanel(p.panelId)} />
                                        <span>{p.name || p.panelId}</span>
                                    </label>
                                ))}
                            </div>
                            {formData.panelIds.length > 0 && (
                                <p style={{ fontSize: '0.8em', color: '#6c757d', marginTop: '-6px', marginBottom: '10px' }}>{formData.panelIds.length} departman seçili. Gelen istekler bu departmanlar arasında sırayla döner.</p>
                            )}

                            <label style={labelStyle}>Yatırım Callback URL</label>
                            <input value={formData.depositCallbackUrl} onChange={e => setFormData({ ...formData, depositCallbackUrl: e.target.value })} style={inputStyle} placeholder="https://siteniz.com/callback/deposit" />

                            <label style={labelStyle}>Çekim Callback URL</label>
                            <input value={formData.withdrawCallbackUrl} onChange={e => setFormData({ ...formData, withdrawCallbackUrl: e.target.value })} style={inputStyle} placeholder="https://siteniz.com/callback/withdraw" />

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                                <button type="button" onClick={() => setShowModal(false)} style={{ padding: '8px 15px', border: 'none', borderRadius: '4px', cursor: 'pointer', backgroundColor: '#6c757d', color: 'white' }}>İptal</button>
                                <button type="submit" style={{ padding: '8px 15px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>{isEditMode ? 'Kaydet' : 'Oluştur'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Başarılı Oluşturma Modalı (Secret Key Gösterimi) */}
            {createdKey && (
                <div style={{ ...modalOverlayStyle, backgroundColor: 'rgba(0,0,0,0.85)' }}>
                    <div style={{ ...modalContentStyle, textAlign: 'center', border: '2px solid #28a745' }}>
                        <div style={{ color: '#28a745', fontSize: '3em', marginBottom: '10px' }}><i className="fas fa-check-circle"></i></div>
                        <h3 style={{ color: '#28a745', marginTop: 0 }}>API Anahtarı Oluşturuldu!</h3>
                        <div style={{ backgroundColor: 'rgba(255, 193, 7, 0.2)', padding: '10px', borderRadius: '5px', border: '1px solid #ffc107', marginBottom: '20px' }}>
                            <strong style={{ color: '#d39e00' }}><i className="fas fa-exclamation-triangle"></i> Secret Key sadece bir kez gösterilir. Lütfen güvenli bir yere kaydedin!</strong>
                        </div>

                        <div style={{ textAlign: 'left', margin: '20px 0' }}>
                            <label style={labelStyle}>API Key</label>
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <input readOnly value={createdKey.apiKey} style={{ ...inputStyle, backgroundColor: '#e9ecef', color: '#000', marginBottom: 0 }} />
                                <button onClick={() => copyToClipboard(createdKey.apiKey, 'apiKey')} style={{ padding: '0 15px', cursor: 'pointer', border: '1px solid var(--input-border)', borderRadius: '4px', backgroundColor: copiedField === 'apiKey' ? '#28a745' : '#fff', color: copiedField === 'apiKey' ? '#fff' : '#333' }}>
                                    <i className={`fas ${copiedField === 'apiKey' ? 'fa-check' : 'fa-copy'}`}></i>
                                </button>
                            </div>

                            <label style={{ ...labelStyle, marginTop: '15px' }}>Secret Key</label>
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <input readOnly value={createdKey.secretKey} style={{ ...inputStyle, backgroundColor: '#e9ecef', color: '#000', fontWeight: 'bold', marginBottom: 0 }} />
                                <button onClick={() => copyToClipboard(createdKey.secretKey, 'secretKey')} style={{ padding: '0 15px', cursor: 'pointer', border: '1px solid var(--input-border)', borderRadius: '4px', backgroundColor: copiedField === 'secretKey' ? '#28a745' : '#fff', color: copiedField === 'secretKey' ? '#fff' : '#333' }}>
                                    <i className={`fas ${copiedField === 'secretKey' ? 'fa-check' : 'fa-copy'}`}></i>
                                </button>
                            </div>
                        </div>

                        <button onClick={() => setCreatedKey(null)} style={{ padding: '10px 30px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1.1em' }}>Anahtar bilgilerini güvenli şekilde kaydettim</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApiKeysPage;